import { Link } from "react-router-dom";

export default function CommonBreadCrumb({ breadcrumbValue }) {

    return (
        <div style={{display:"flex", alignItems:"center"}}>
            <nav className="breadcrumb">
                <ul className="breadcrumb-links">
                    <li>
                        <Link to="/" className="breadcrumb-box">
                            <svg
                                className="breadcrumb-icon-home"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <span className="breadcrumb-text" style={{ color: '#ff601f' }}>Dashboard</span>
                        </Link>
                    </li>
                    {breadcrumbValue && breadcrumbValue.length > 0 && breadcrumbValue.map((value, i) => {
                        const isLast = i === breadcrumbValue.length - 1;
                        return (
                            <li key={i}>
                                <div className="breadcrumb-box">
                                    <svg
                                        className="breadcrumb-icon"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                            clipRule="evenodd"
                                        />
                                    </svg>

                                    {value.link ? (
                                        <Link
                                            to={value.link}
                                            className="breadcrumb-text"
                                            style={{ color: '#ff601f' }}
                                        >
                                            {value.title}
                                        </Link>
                                    ) : (
                                        <span className="breadcrumb-text" style={{ color: value.activeColor ? '#ff601f' : '#9f9d9c' }}>
                                            {value.title}
                                        </span>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    )
}